@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: inherit;
}

.inner {
    composes: container from "../../styles/composable/layout.module.css";
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 16px;

    // These queries are a little odd but it was the fastest path to fixing an
    // unexpected layout at 1024px
    @media ($above-tablet) {
        display: block;
    }

    @media ($below-mobile) {
        display: block;
    }
}

.hotspotImage {
    --image-size: 50vw;

    position: relative;
    width: var(--image-size);
    height: var(--image-size);
    margin: 0 auto;
    flex-shrink: 0;

    @media ($below-mobile) {
        width: 100%;
        height: auto;
        aspect-ratio: 1;
    }

    img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.hotspotMap {
    position: absolute;
    inset: 0;
}

.hotspot {
    position: absolute;
    top: var(--top);
    left: var(--left);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--robins-blue);
    border-radius: 40px;
    box-shadow: var(--box-shadow-1);
    color: var(--navy);
    cursor: default;
    font: var(--font-h-18);
    text-align: center;
    translate: -50% -50%;

    @media ($above-tablet) {
        display: none;
    }
}
